import React from 'react';
import { Link } from 'react-router-dom';
import { FiYoutube, FiGithub, FiTwitter } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-dark-900 border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-white">Clarity<span className="text-cyan-400 font-light">in</span>Chaos</h3>
            <div className="space-y-3">
              <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                Independent analysis, spiritual depth, and global reflection. Finding meaning in the noise of the modern world.
              </p>
              <p className="text-[11px] text-gray-600 font-light italic leading-relaxed max-w-xs">
                An independent project inspired by P. R. Sarkar’s PROUT.
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><Link to="/" className="hover:text-cyan-400 transition-colors">Home</Link></li>
              <li><Link to="/chatbots" className="hover:text-cyan-400 transition-colors">AI Assistants</Link></li>
              <li><a href="https://www.youtube.com/@universalvision00" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">YouTube Channel</a></li>
            </ul>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">Connect</h4>
            <div className="flex space-x-4">
              <a href="https://www.youtube.com/@universalvision00" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors text-xl">
                <FiYoutube />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-xl">
                <FiTwitter />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-xl">
                <FiGithub />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center text-xs text-gray-600">
          <p>&copy; {new Date().getFullYear()} Clarity in Chaos. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;